import { render, staticRenderFns } from "./list-detail.vue?vue&type=template&id=1a859d05&scoped=true"
var script = {}
import style0 from "./list-detail.vue?vue&type=style&index=0&id=1a859d05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a859d05",
  null
  
)

export default component.exports